{
  "processing": "Processing verification...",
  "loadingIframe": "Loading ID verification...",
  "issueTitle": "ID Verification Issue",
  "notConfigured": "ID verification is not properly configured for this warehouse.",
  "notSuccessful": "ID verification was not successful. Please try again or contact the warehouse.",
  "couldNotCompleteProceed": "ID verification could not be completed, but you may proceed with check-in.",
  "processFailed": "Failed to process ID verification. Please try again.",
  "processingFailedProceed": "ID verification processing failed, but you may proceed with check-in.",
  "genericError": "An error occurred during ID verification. Please try again.",
  "issueProceed": "ID verification encountered an issue, but you may proceed with check-in.",
  "requiredTryAgain": "ID verification is required to complete check-in. Please try again.",
  "checkInFailedTitle": "Unable to check-in",
  "checkInFailedMessage": "Your ID could not be validated"
}
